<template>
  <scoped v-if="value">
    <TextInput
      v-model:value="value.name"
      title="Name"
      :readOnly="readOnly"
    />
    <TextInput
      v-model:value="value.memorandum"
      title="Memorandum"
      :readOnly="readOnly"
      multiline
    />
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import TextInput from "@/components/inputs/text.vue"
  import {PropType, ref} from "vue"
  import {Trademark} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"

  defineProps({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  })

  const value = defineModel("value", {
    default: null,
    required: true,
    type: Object as PropType<Trademark>
  })

  const error = ref<Error>(null)
</script>
